<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="specific-commerce">
      <Title jpn="Legge sulle transazioni commerciali specificate" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Nome della società operativa</span>
            <span class="text">Hatchi Co., Ltd.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">persona rappresentativa</span>
            <span class="text">Ken Yatsuka</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Indirizzo di registrazione della società/indirizzo dell'ufficio commerciale</span>
            <span class="text">547-0011</span>
            <span class="text">3-39 Nagayoshi Deto 7-chome, Hirano-ku, Città di Osaka, Prefettura di Osaka</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">numero di telefono</span>
            <span class="text">06-6643-9996</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">(*Orari reception: feriali 10:00-17:00)</span>
            <span class="text">indirizzo e-mail</span>
            <span class="text">support@xeroplace.jp</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">*Per richieste di informazioni utilizzare la chat del sito. In linea di principio, risponderemo entro 2 giorni lavorativi.</span>
            <span class="text">prezzo</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
        class="shadow-box-title-description"
        title=""
        >
        <div class="text-container left">
            <span class="text">Visualizzazione per ciascun prodotto</span>
            <span class="text">Spese necessarie diverse dal prezzo del prodotto</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Costi relativi alle apparecchiature per l'utilizzo dei servizi forniti dalla nostra azienda, tariffe di connessione Internet, tariffe di comunicazione a pacchetto, imposta sui consumi e tariffe di trasferimento per il pagamento.</span>
            <span class="text">Tempi di consegna</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Quando si accettano candidature</span>
            <span class="text">Quantità di vendita</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Non ci sono specifiche specifiche.</span>
            <span class="text">Metodo di pagamento</span>
            <span class="text">Accettiamo carte di credito, PayPal e Amazon Pay.</span>
            <span class="text">*Non possiamo accettare cancellazioni per comodità del cliente dopo il pagamento. Grazie per la comprensione.</span>
            <span class="text">Se il pagamento non viene effettuato entro la scadenza, verrà automaticamente annullato.</span>
            <span class="text">Periodo di pagamento</span>
            <span class="text">Carta di credito: in base ai termini e alle condizioni della società emittente della carta di credito.</span>
            <span class="text">PayPal: basato sui termini PayPal.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Amazonpay: basato sui termini e condizioni di Amazonpay.</span>
            <span class="text">Politica di restituzione e scadenza</span>
            <span class="text">Come regola generale, non accettiamo resi o cambi, ma se la nostra colpa è al 100%, risponderemo.</span>
            <span class="text">Tuttavia, non possiamo rispondere nei seguenti casi. Grazie per la comprensione.</span>
            <span class="text">Se l'articolo viene smarrito o danneggiato durante il processo di consegna</span>
            <span class="text">Se non è presente alcuna registrazione video degli articoli non aperti come BOX ecc.</span>
            <span class="text">*Prestiamo particolare attenzione durante l'ispezione dei prodotti riretratti.</span>
            <span class="text">Se sono trascorsi più di 10 giorni dall'arrivo del prodotto</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">Se trovi graffi, ecc. su un articolo valutato come PSA e accettiamo la tua richiesta di cambio o restituzione in base a tale motivo.</span>
            <span class="text">Licenza commerciale di antiquario</span>
            <span class="text">No 431370066203</span>
            <span class="text">Hatchi Co., Ltd.</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';

export default {
  name: 'SpecificCommerce',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),

  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.specific-commerce{
  width: 100%;
  max-width: 1000px;
  padding: 30px 20px 0;
  margin: 0 auto;
  .specific-commerce-title{
    display: flex;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          a {
            color: blue!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
          &.none{
            color: red;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
table.code {
  width: 100%;
  th, td {
    font-size: 16px;
    color: $white;
  }
  th {
    font-weight: normal;
    text-align: left;
    padding-right: 10px;
    width: 200px;
  }
  td {
    text-align: left;
    padding-left: 10px;
  }
}
@media screen and  (max-width: $tabletWidth) {
  .specific-commerce{
    .scroll-container{
      .shadow-box-title-description{
        .text-container{
          .text{
            font-size: 14px;
          }
        }
      }
    }
  }
  table.code {
    width: 100%;
    th, td {
      display: block;
      font-size: 14px;
    }
    th {
      text-align: left;
      padding-right: 0;
      &:after {
        content: '';
      }
    }
    td {
      text-align: left;
      padding-left: 0;
      padding-bottom: 10px;
    }
  }
  .left {
    text-align: left!important;
  }
}
</style>
